<template>

</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

import { auth } from '../../services/auth_service'
import { oauth } from '../../services/oauth_admin_service'

@Component
export default class Code extends Vue {
  async created() {
    //const params = new URLSearchParams(window.location.search)
    if (window.history.replaceState) {
      window.history.replaceState({}, document.title, `#${this.$route.path}`)
    } else {
      window.location.assign(`#/${this.$route.path}`)
    }
    
    if (await oauth.requestToken(this.$route.query['code'] as string)) {
      await auth.authenticate({})
      this.$router.replace({ name: 'dashboard' })
    } else {
      this.$router.replace({ name: 'fail' })
    }
  }
}
</script>